var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1280,
  height: 540,
  viewBox: "0 0 1280 540",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H1280V407.708L1175.64 540L133.413 239.49L0 407.708V0Z",
  fill: "url(#paint0_linear_197_949)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_197_949",
  x1: 231.041,
  y1: 674.471,
  x2: 1667.54,
  y2: 491.167,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#597EF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#50E3C2"
})))));
export default __webpack_public_path__ + "teg/media/background.8927c3b4.svg";
export { SvgComponent as ReactComponent };